import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { setLoading } from '../../store/reducers/global-reducer';
import { connect } from 'react-redux';
import store from '../../store/index';
import {
    Chart as ChartJS, ArcElement, CategoryScale,
    LinearScale,
    BarElement, Title, Tooltip, Legend
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import axios from 'axios';
import nicon from '../../assets/images/nicon.png';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import { PieChart } from '@mui/x-charts/PieChart';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import arrow_back from '../../assets/icons/arrow-back.svg'

class ManageReportsServices extends Component {
    constructor(props) {
        super(props)
        this.authInfo = store.getState().auth.authInfo;
        this.state = {
            weeksInYear: [], // All weeks in the current year
            currentWeekIndex: 0, // Index of the currently displayed week
            latestCustomers: [],
            bestSellingProducts: [],
            allServiceProjectsData: [], // Changed from allServiceOrdersData
            monthlyServiceProjectCounts: [], // Changed from monthlyServiceCounts
            serviceTopCategories: [],
            projectsThisMonth: [], // Changed from orderThisMonth
            showMilestonesModal: false,
            selectedProject: null,
            selectedProjectMilestones: [],
            loadingMilestones: false
        };
        toast.configure();

        // Updated column definitions for projects instead of orders
        this.all_Reports = [
            {
                name: 'PROJECT ID',
                selector: (row, i) => row._id,
                sortable: true,
                width: '150px'
            },
            {
                name: 'PROJECT TITLE',
                selector: (row, i) => row.title,
                sortable: true,
                wrap: true
            },
            {
                name: 'BUDGET',
                selector: (row, i) => `$${row.budget}`,
                sortable: true,
            },
            {
                name: 'STATUS',
                selector: (row, i) => row.status,
                sortable: true,
                cell: (row) => (
                    <span className={`badge ${this.getStatusBadgeClass(row.status)}`}>
                        {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                    </span>
                )
            },
            {
                name: 'START DATE',
                selector: (row, i) => {
                    const startDate = new Date(row.startDate || row.createdAt);
                    return startDate.toLocaleDateString('en-US');
                },
                sortable: true,
            },
            {
                name: 'CREATED DATE',
                selector: (row, i) => {
                    const createdAt = new Date(row.createdAt);
                    return createdAt.toLocaleDateString('en-US');
                },
                sortable: true,
            },
            {
                name: 'ACTIONS',
                cell: (row) => (
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => this.handleViewMilestones(row)}
                    >
                        Milestones
                    </button>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: '140px'
            }
        ];
    }

    componentDidMount() {
        this.getReportData();
        this.getServiceTopSellingCategories();
        this.getServiceProjectsTotalForMonth();
    }

    // Helper method for status badge styling
    getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
            case 'completed':
                return 'bg-success';
            case 'in-progress':
                return 'bg-primary';
            case 'pending':
                return 'bg-warning text-dark';
            case 'cancelled':
                return 'bg-danger';
            default:
                return 'bg-secondary';
        }
    }

    // Handle viewing milestones for a project
    handleViewMilestones = async (project) => {
        this.setState({ 
            selectedProject: project, 
            showMilestonesModal: true,
            loadingMilestones: true 
        });

        try {
            const response = await axios.get(`admin/project/${project._id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });

            if (response.data && response.data.milestones) {
                this.setState({ 
                    selectedProjectMilestones: response.data.milestones,
                    loadingMilestones: false 
                });
            }
        } catch (error) {
            console.error("Error fetching project milestones:", error);
            toast.error("Failed to fetch project milestones");
            this.setState({ loadingMilestones: false });
        }
    }

    // Close milestones modal
    closeMilestonesModal = () => {
        this.setState({ 
            showMilestonesModal: false,
            selectedProject: null,
            selectedProjectMilestones: [],
            loadingMilestones: false
        });
    }

    // Get milestone status badge class
    getMilestoneStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case 'paid':
                return 'badge bg-success';
            case 'approved':
                return 'badge bg-info';
            case 'completed':
                return 'badge bg-primary';
            case 'in-progress':
                return 'badge bg-warning text-dark';
            case 'rejected':
                return 'badge bg-danger';
            case 'pending':
                return 'badge bg-secondary';
            default:
                return 'badge bg-light text-dark';
        }
    }

    // Updated to call the new API endpoint
    getReportData = async () => {
        try {
            this.setState({ loading: true });
            const url = "admin/getServiceReport"; // Updated endpoint
            const response = await axios.get(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });
            const data = response.data.data;
            this.setState({ 
                allServiceProjectsData: data.allProjects, // Updated field name
                monthlyServiceProjectCounts: data.monthlyServiceProjectCounts, // Updated field name
                loading: false 
            });
        } catch (error) {
            console.error("There was an error fetching Service Projects data", error);
            this.setState({ loading: false });
            toast.error("Failed to fetch service reports data");
        }
    };

    handleSubmit = (values, { resetForm }) => {
        const { dispatch } = this.props;
        dispatch(setLoading({ loading: true }));
        axios.post('admin/coupons', values, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        }).then(response => {
            toast.dismiss();
            if (response.data.status) {
                toast.success(response.data.message, { autoClose: 3000 });
                resetForm();
            }
        }).catch(error => {
            toast.dismiss();
            if (error.response) {
                toast.error(error.response.data.message, { autoClose: 3000 });
            }
        }).finally(() => {
            setTimeout(() => {
                dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }

    service_column = [
        {
            name: "Image",
            selector: (row, i) => (
                <img
                    src={row.featuredImage}
                    alt="Not selected"
                    style={{ width: "150px", height: "100px" }}
                />
            ),
            sortable: true,
        },
        {
            name: "Service ID",
            selector: (row, i) => row.serviceCode,
            sortable: true,
        },
        {
            name: "Service Name",
            selector: (row, i) => row.name,
            sortable: true,
        },
        {
            name: "Category",
            selector: (row, i) => row.category.categoryName,
            sortable: true,
        },
        {
            name: "Charges",
            selector: (row, i) => `$ ${row.charges}`,
            sortable: true,
        },
        {
            name: "Service Start Date & Time",
            selector: (row, i) => row.createdAt,
            sortable: true,
            width: "200px",
            cell: (row) => {
                const options = { year: "numeric", month: "long", day: "numeric" };
                const date = new Date(row.createdAt).toLocaleDateString(
                    "en-US",
                    options
                );
                return <div>{date}</div>;
            },
        },
        {
            name: "Status",
            selector: (row, i) =>
                row.isActive === true ? (
                    <p className="p-1 text-white bg-success  bg-opacity-6 border-info rounded">
                        Active
                    </p>
                ) : (
                    <p className="p-1 text-white bg-danger  bg-opacity-6 border-info rounded">
                        In-Active
                    </p>
                ),
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        onClick={() => this.handleDetails(row)}
                        className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
                    >
                        Details
                    </button>
                    <button
                        onClick={() => this.handleEdit(row)}
                        className="custom_btn btn_yellow_bordered w-auto btn btn-width action_btn_new"
                    >
                        Edit
                    </button>
                    {row.isActive ? (
                        <button
                            onClick={() => this.handleUpdateStatus(row._id, row.isActive)}
                            className="custom_btn btn_yellow_bordered  w-auto  btn btn-width action_btn_new"
                        >
                            Inactive
                        </button>
                    ) : (
                        <button
                            onClick={() => this.handleUpdateStatus(row._id, row.isActive)}
                            className="custom_btn btn_yellow_bordered w-auto  btn btn-width action_btn_new"
                        >
                            Active
                        </button>
                    )}
                </>
            ),
        },
    ];

    getServiceTopSellingCategories = () => {
        axios.get("admin/getServiceTopSellingCategories", {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        })
            .then((response) => {
                const data = response.data.data.data;
                const topCategories = data.map((item) => ({
                    value: item.count,
                    label: item.name,
                }));
                this.setState({ serviceTopCategories: topCategories, loading: false });
            })
            .catch((error) => {
                if (error.response && error.response.data.status === false) {
                    console.log("error", error.response.data.message)
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 300);
            });
    };

    // Updated method name and logic for projects
    getServiceProjectsTotalForMonth = () => {
        axios.get("admin/getServiceProjectsTotalForMonth", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
            .then((response) => {
                const data = response.data.data.data;
                this.setState({ projectsThisMonth: data, loading: false });
            })
            .catch((error) => {
                if (error.response && error.response.data.status === false) {
                    console.log("error", error.response.data.message)
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 300);
            });
    };

    render() {
        const { 
            monthlyServiceProjectCounts, 
            allServiceProjectsData, 
            serviceTopCategories, 
            projectsThisMonth,
            showMilestonesModal,
            selectedProject,
            selectedProjectMilestones,
            loadingMilestones
        } = this.state;
        
        const colors = ['rgb(2, 178, 175)', 'rgb(46, 150, 255)', 'rgb(184, 0, 216)', 'rgb(96, 0, 155)'];
        console.log('allServiceProjectsData--', allServiceProjectsData)

        ChartJS.register(CategoryScale,
            LinearScale,
            BarElement,
            Title, ArcElement, Tooltip, Legend);

        const optionsBar = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top'
                },
                title: {
                    display: false,
                    text: 'Chart.js Bar Chart',
                }
            },
        };
        
        const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const dataBar = {
            labels,
            datasets: [
                {
                    label: 'Service Projects', // Updated label
                    data: monthlyServiceProjectCounts, // Updated data source
                    backgroundColor: [
                        '#3c8dbc',
                        '#f56954',
                        '#f39c12',
                        '#CCCCCC',
                        '#8e44ad',
                        '#3498db',
                        '#e74c3c',
                        '#2ecc71',
                        '#f1c40f',
                        '#e67e22',
                        '#1abc9c',
                        '#9b59b6',
                    ],
                },
            ],
        };

        const data = {
            labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
            datasets: [
                {
                    labels: [
                        'Total Budget',
                        'Received Payment',
                        'Earning',
                    ],
                    data: [10, 20, 30],
                    backgroundColor: [
                        '#3c8dbc',
                        '#f56954',
                        '#f39c12',
                    ],
                },
            ],
        };

        return (
            <React.Fragment>
                <Header />
                <div className="inr_top_page_title">
                    <h2>Service Reports</h2>
                </div>
                <Helmet>
                    <title>{"Admin - Reports - Pay Earth"}</title>
                </Helmet>
                <div className="cumm_page_wrap pt-4 pb-1 admin-dashboard-wrapper reports_page_wrapper">
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between report_tabing_nav">
                            <div className="report_tab_link">
                                <ul className="d-flex mb-0">
                                    <li><Link to="/admin/product-reports">Product</Link></li>
                                    <li className="activeNav"><Link to="/admin/service-reports">Service</Link></li>
                                </ul>
                            </div>
                            <button
                                type="button"
                                className="btn custum_back_btn btn_yellow w-auto"
                                onClick={() => window.history.back()}
                            >
                                <img src={arrow_back} alt="back" />&nbsp;
                                Back
                            </button>
                        </div>
                        <div className="report_tab_item service_report_tab_item">
                            <div className="rep_chart_wrapper">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="card bg-white rounded-3">
                                            <div className="card-header">
                                                Top Service Categories
                                            </div>
                                            <div className="tsc_box bg-white p-3">
                                                <div className="row">
                                                    <div className="col-lg-6 m-0 p-0">
                                                        <ul className="list-unstyled m-0 p-0">
                                                            {serviceTopCategories.map((item, index) => (
                                                                <li
                                                                key={index}
                                                                className="d-grid align-items-start mb-2"
                                                                style={{
                                                                    gridTemplateColumns: "14px auto",
                                                                    columnGap: "8px",
                                                                    lineHeight: "1.4",
                                                                }}
                                                                >
                                                                <i
                                                                    style={{
                                                                    color: colors[index % colors.length],
                                                                    fontSize: "10px",
                                                                    marginTop: "6px",
                                                                    }}
                                                                    className="fa fa-circle"
                                                                ></i>
                                                                <span
                                                                    className="small fw-medium text-dark"
                                                                    style={{ wordBreak: "break-word" }}
                                                                >
                                                                    {item.label}
                                                                </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    <div className="tsc_img col-lg-6 m-0 p-0">
                                                        <Box sx={{ width: '100%' }}>
                                                            <PieChart
                                                                height={200}
                                                                slotProps={{
                                                                    legend: { hidden: true },
                                                                }}
                                                                series={[
                                                                    {
                                                                        data: serviceTopCategories,
                                                                        innerRadius: 80,
                                                                        cx: 120,
                                                                        cy: 100,
                                                                    }
                                                                ]}
                                                            />
                                                        </Box>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="card bg-white rounded-3">
                                            <div className="card-header">
                                                Monthly Service Projects Report
                                            </div>
                                            <div className="rep_chart_item chart_right">
                                                <Bar options={optionsBar} data={dataBar} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="card bg-white rounded-3">
                                            <div className="card-header">
                                                Projects this Month
                                            </div>                                          
                                            <div className="rep_chart_item orderWeek">
                                                {projectsThisMonth ? (
                                                    <div className="total_weeklly_order">
                                                        <h2>${projectsThisMonth?.totalBudget || 0}</h2>
                                                        <h4>Avg ${projectsThisMonth?.averageBudget || 0}/Project</h4>
                                                        <p>{projectsThisMonth?.projectCount || 0} Projects</p>
                                                    </div>
                                                ) : (
                                                    <div className="total_weeklly_order">
                                                        <h2>No Projects</h2>
                                                        <h4>This Month</h4>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card bg-white rounded-3 pt-3 pb-5 report_listing_row">
                                <div className="dash_inner_wrap">
                                    <div className="col-md-12 pt-2 pb-3 d-flex justify-content-between align-items-center flex_mob_none">
                                        <div className="dash_title">All Service Projects Reports</div>
                                    </div>
                                </div>

                                <DataTableExtensions
                                    columns={this.all_Reports}
                                    data={allServiceProjectsData}
                                >
                                    <DataTable
                                        pagination
                                        noHeader
                                        highlightOnHover
                                        defaultSortField="createdAt"
                                        defaultSortAsc={false}
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                    />
                                </DataTableExtensions>
                            </div>                            
                        </div>
                    </div>
                </div>

                {/* Milestones Modal */}
                {showMilestonesModal && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Project Milestones - {selectedProject?.title}
                                    </h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        onClick={this.closeMilestonesModal}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {loadingMilestones ? (
                                        <div className="text-center p-4">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Project Summary */}
                                            <div className="row mb-4">
                                                <div className="col-md-3">
                                                    <div className="card text-center">
                                                        <div className="card-body">
                                                            <h6 className="card-title">Total Budget</h6>
                                                            <h4 className="text-primary">${selectedProject?.budget}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card text-center">
                                                        <div className="card-body">
                                                            <h6 className="card-title">Total Milestones</h6>
                                                            <h4 className="text-info">{selectedProjectMilestones.length}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card text-center">
                                                        <div className="card-body">
                                                            <h6 className="card-title">Approved</h6>
                                                            <h4 className="text-success">
                                                                {selectedProjectMilestones.filter(m => m.status === 'approved' || m.status === 'paid').length}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card text-center">
                                                        <div className="card-body">
                                                            <h6 className="card-title">Rejected</h6>
                                                            <h4 className="text-danger">
                                                                {selectedProjectMilestones.filter(m => m.isRejected).length}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Milestones List */}
                                            <div className="milestones-list">
                                                <h6 className="mb-3">Milestone Details</h6>
                                                {selectedProjectMilestones.length > 0 ? (
                                                    selectedProjectMilestones.map((milestone, index) => (
                                                        <div key={milestone._id} className="card mb-3">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                                                            <h6 className="card-title mb-1">
                                                                                Milestone {milestone.milestoneNumber}: {milestone.name}
                                                                            </h6>
                                                                            <span className={this.getMilestoneStatusBadge(milestone.status)}>
                                                                                {milestone.status.charAt(0).toUpperCase() + milestone.status.slice(1)}
                                                                            </span>
                                                                        </div>
                                                                        <p className="card-text text-muted mb-2">{milestone.description}</p>
                                                                        
                                                                        {/* Rejection Details */}
                                                                        {milestone.isRejected && milestone.rejectionDetails && (
                                                                            <div className="alert alert-danger mt-2">
                                                                                <small><strong>Rejection Reason:</strong></small>
                                                                                <p className="mb-1">{milestone.rejectionDetails.rejectionReason}</p>
                                                                                <small className="text-muted">
                                                                                    Rejected on: {new Date(milestone.rejectionDetails.rejectionDate).toLocaleDateString()}
                                                                                </small>
                                                                            </div>
                                                                        )}

                                                                        {/* Payment Details */}
                                                                        {milestone.isPaid && milestone.paymentDetails && (
                                                                            <div className="alert alert-success mt-2">
                                                                                <small><strong>Payment Details:</strong></small>
                                                                                <p className="mb-1">Invoice: {milestone.paymentDetails.invoiceNo}</p>
                                                                                <p className="mb-1">Amount: ${milestone.paymentDetails.amountPaid}</p>
                                                                                <small className="text-muted">
                                                                                    Paid on: {new Date(milestone.paymentDetails.paymentDate).toLocaleDateString()}
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-4 text-end">
                                                                        <div className="milestone-meta">
                                                                            <p className="mb-1"><strong>Amount:</strong> ${milestone.amount}</p>
                                                                            <p className="mb-1">
                                                                                <strong>Due Date:</strong> {' '}
                                                                                {new Date(milestone.dueDate).toLocaleDateString()}
                                                                            </p>
                                                                            {milestone.completionDate && (
                                                                                <p className="mb-1">
                                                                                    <strong>Completed:</strong> {' '}
                                                                                    {new Date(milestone.completionDate).toLocaleDateString()}
                                                                                </p>
                                                                            )}
                                                                            <p className="mb-1">
                                                                                <small className="text-muted">{milestone.paymentMessage}</small>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center p-4">
                                                        <p className="text-muted">No milestones found for this project.</p>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary" 
                                        onClick={this.closeMilestonesModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer />
            </React.Fragment>
        )
    }
}

export default connect(setLoading)(ManageReportsServices);